import { z } from 'zod';
import { timestamp } from '@/lib/schemas/primitives';

export const fileInfoSchema = z.object({
  id: z.number(),
  driveViewLink: z.string(),
  mimeType: z.string(),
  filename: z.string(),
  uploadedAt: timestamp,
  fileSequence: z.number(),
});
export type FileInfo = z.infer<typeof fileInfoSchema>;

export const itemPictureSchema = z.object({
  id: z.number(),
  driveViewLink: z.string(),
  mimeType: z.string(),
  filename: z.string(),
  uploadedAt: timestamp,
});
export type ItemPicture = z.infer<typeof itemPictureSchema>;
